<template>
  <div>
    <b-form-input
      v-model="displayValue"
      size="sm"
      type="text"
      :required="requared"
      :state="state"
      :disabled="disabled"
      class="rp"
      @blur="onBlureInputPrice(value)"
      @focus="isInputActive = true">
    </b-form-input>

  </div>
</template>

<script>

  export default {
    name: 'PriceInput',

    props: {
      value: {
        type: Number,
        default: 0
      },
      requared: {
        type: Boolean,
        default: false
      },

      disabled: {
        type: Boolean,
        default: false
      },

      state: {
        type: Boolean,
        default: false
      }
    },

    data: function () {
      return {
        isInputActive: false
      };
    },

    computed: {
      displayValue: {
        get: function () {

          if (this.value === null) {
            return;
          }

          if (this.isInputActive) {
            return this.value.toString();
          } else {
            return '' + this.value.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,');
          }
        },
        set: function (modifiedValue) {
          let newValue = parseFloat(modifiedValue.replace(/[^\d.]/g, ''));
          if (isNaN(newValue)) {
            newValue = null;
          }
          this.$emit('input', newValue);
        }
      }
    },

    methods: {
      onBlureInputPrice(modifiedValue) {
        this.isInputActive = false;
        if (modifiedValue) {
          modifiedValue = parseFloat(modifiedValue.toFixed(2));
        }
        this.$emit('input', modifiedValue);
      }
    }
  };
</script>

<style lang="stylus" scoped>
    .rp {
      padding-right: calc(1.5em + 0.75rem);
    }
</style>
